import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DatePickerModule } from 'primeng/datepicker';
import { ButtonModule } from 'primeng/button';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-datepicker',
  standalone: true,
  imports: [CommonModule, FormsModule, DatePickerModule, ButtonModule, SelectButtonModule, SelectModule],
  templateUrl: './datepicker.component.html',
  styleUrl: './datepicker.component.scss'
})
export class DatepickerComponent implements OnInit {
  @Input() label = 'Ingresa las fechas';
  @Input() selectedFilterRange = 1;
  @Output() updateDates = new EventEmitter<{ from: Date; to: Date }>();

  rangeDates: Date[] = [];
  selectedQuickFilter = 1;

  quickOptions = [
    { label: 'Semana', value: 1 },
    { label: 'Mes', value: 2 },
    { label: 'Año', value: 3 },
    { label: 'Sem. pasada', value: 4 },
    { label: 'Mes pasado', value: 5 },
    { label: 'Personalizado', value: -1 }
  ];

  get isCustomRange() { return this.selectedQuickFilter === -1; }

  selectFilter(value: number) {
    this.selectedQuickFilter = value;
    if (value !== -1) {
      this.applyQuickFilter(value);
    }
  }

  ngOnInit() {
    this.selectedQuickFilter = this.selectedFilterRange;
    this.applyQuickFilter(this.selectedQuickFilter);
  }

  onQuickFilterChange(event: any) {
    this.selectedQuickFilter = event.value;
    if (this.selectedQuickFilter !== -1) {
      this.applyQuickFilter(this.selectedQuickFilter);
    }
  }

  onRangeSelect() {
    if (this.rangeDates[0] && this.rangeDates[1]) {
      this.emit(this.rangeDates[0], this.rangeDates[1]);
    }
  }

  applyQuickFilter(value: number) {
    const today = new Date();
    let from: Date;
    let to: Date;

    switch (value) {
      case 1: // Current week
        from = this.startOfWeek(today);
        to = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 6);
        break;
      case 2: // Current month
        from = new Date(today.getFullYear(), today.getMonth(), 1);
        to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        break;
      case 3: // Current year
        from = new Date(today.getFullYear(), 0, 1);
        to = new Date(today.getFullYear(), 11, 31);
        break;
      case 4: // Last week
        const lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
        from = this.startOfWeek(lastWeek);
        to = new Date(from.getFullYear(), from.getMonth(), from.getDate() + 6);
        break;
      case 5: // Last month
        from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        to = new Date(today.getFullYear(), today.getMonth(), 0);
        break;
      case 6: // Last year
        from = new Date(today.getFullYear() - 1, 0, 1);
        to = new Date(today.getFullYear() - 1, 11, 31);
        break;
      default:
        from = today;
        to = today;
    }

    this.rangeDates = [from, to];
    this.emit(from, to);
  }

  private startOfWeek(d: Date): Date {
    const day = d.getDay();
    return new Date(d.getFullYear(), d.getMonth(), d.getDate() - day);
  }

  private emit(from: Date, to: Date) {
    this.updateDates.emit({ from, to });
  }
}
